import { createSlice } from '@reduxjs/toolkit';
import {
	applyCouponBasket, createOrderTracks,
	createOrderSubscribe,
	getBasketSubscribesPrice,
	getBasketTracksPrice,
	getTracksBasket,
} from '../actions/basketActions';

const initialState = {
  tracks: [],
  coupon: null,
  couponName: '',
  orderLink: null,
  message: '',
  licenses: [],
  licenseBasket: {},
  activeLicense: {},
  payType: 1,
  isLoading: false,
  basket_id: null,
  userChangedLicense: false,
  defaultLicenseCode: null, 
};

const basketSlice = createSlice({
	name: 'basket',
	initialState,
	reducers: {
		setBasketProperty: (state, { payload }) => {
		state[payload.property] = payload.value;
		},
		setActiveLicense: (state, { payload }) => {
			const selectedLicense = state.licenses.find((licence) => licence.id === payload.id);
			if (selectedLicense) {
				state.activeLicense = selectedLicense;
				const defaultLicense = state.licenses.find(lic => lic.checked);
				state.userChangedLicense = !defaultLicense || selectedLicense.id !== defaultLicense.id;
			}
		},
		setPayType: (state, { payload }) => {
		state.payType = payload;
		},
		clearActiveSubscribe: (state) => {
		state.activeLicense = {};
		state.licenses = [];
		state.licenseBasket = {};
		state.coupon = null;
		state.couponName = '';
		state.orderLink = null;
		state.message = 'Ваша корзина пуста';
		state.userChangedLicense = false;
		state.defaultLicenseId = null;
		},
		resetUserLicenseChange: (state) => {
		state.userChangedLicense = false;
		},
	},
	extraReducers: {
		[getBasketTracksPrice.pending]: (state) => {
			state.isLoading = true;
		},
		[getBasketSubscribesPrice.pending]: (state) => {
			state.isLoading = true;
		},
		[getBasketTracksPrice.rejected]: (state) => {
			state.isLoading = false;
		},
		[getBasketSubscribesPrice.rejected]: (state) => {
			state.isLoading = false;
		},
		[getTracksBasket.fulfilled]: (state, { payload }) => {
			if (payload.data.data) {
				state.tracks = payload.data.data;
				state.message = '';
			}
			if (!payload.data.result) {
				state.message = payload.data.message;
			}
			state.isLoading = false;
		},
		[getBasketTracksPrice.fulfilled]: (state, { payload }) => {
			state.isLoading = false;
			if (!payload.data.message) {
				state.licenses = payload.data;
				
				const checkedLicense = payload.data.find(lic => lic.checked);
				if (checkedLicense) {
				state.activeLicense = checkedLicense;
				state.userChangedLicense = false;
				}
			}
		},
		[getBasketSubscribesPrice.fulfilled]: (state, { payload }) => {
			state.isLoading = false;
			if (!payload.data.message) {
				state.licenses = payload.data.items;
				state.basket_id = payload.data.basket_id;
			}
		},
		[applyCouponBasket.fulfilled]: (state, { payload }) => {
			state.coupon = payload.data;
		},
		[createOrderTracks.fulfilled]: (state, { payload }) => {
			if (payload.data.result) {
				state.orderLink = payload.data.redirect_link;
			}
		},
		[createOrderSubscribe.fulfilled]: (state, { payload }) => {
			if (payload.data.result) {
				state.orderLink = payload.data.redirect_link;
			}
		},
	},
});

export const { 
	setBasketProperty, 
	setActiveLicense, 
	setPayType, 
	clearActiveSubscribe,
	resetUserLicenseChange 
} = basketSlice.actions;
export default basketSlice.reducer;